import { render, staticRenderFns } from "./editMemberHeader.vue?vue&type=template&id=31a52cf5&scoped=true&lang=pug"
import script from "./editMemberHeader.js?vue&type=script&lang=js&external"
export * from "./editMemberHeader.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a52cf5",
  null
  
)

export default component.exports